<template>
  <div>
    <div class="content-skeleton" :class="[source === 'search' ? 'search' : '']">
      <div class="animated-background">
        <div class="background-masker header-top"></div>
        <div class="background-masker header-left"></div>
        <div class="background-masker header-right"></div>
        <div class="background-masker header-bottom"></div>
        <div class="background-masker subheader-left"></div>
        <div class="background-masker subheader-right"></div>
        <div class="background-masker subheader-bottom"></div>
        <div class="background-masker content-top"></div>
        <template v-if="source !== 'search'">
			<div class="background-masker content-first-end"></div>
			<div class="background-masker content-second-line"></div>
			<div class="background-masker content-second-end"></div>
			<div class="background-masker content-third-line"></div>
			<div class="background-masker content-third-end"></div>
			<div class="background-masker content-fourth-line"></div>
			<div class="background-masker content-fourth-end"></div>
        </template>
      </div>
    </div>	  
  </div>
</template>

<script>
	export default {
		name: 'ContentSkeleton',
		props: ['source'],
	}
</script>

<style lang="scss" scoped>
	.content-skeleton {
		background: #fff;
		border: 1px solid #efefef;
		border-radius: 6px;
		padding: 20px;
		margin: 0 auto;
		width: 100%;

		&.search {
			height: 88px !important;
			.animated-background {
				height: 50px !important;
			}
		}
	}

	.animated-background {
		animation-duration: 1s;
		animation-fill-mode: forwards;
		animation-iteration-count: infinite;
		animation-name: placeHolderShimmer;
		animation-timing-function: linear;
		background: #f6f7f8;
		background: linear-gradient(to right, #eeeeee 8%, #f6f7f8 18%, rgb(241, 243, 246) 33%);
		background-size: 800px 104px;
		height: 130px;
		position: relative;
	}

	@keyframes placeHolderShimmer{
		0%{
				background-position: -468px 0
		}
		100%{
				background-position: 468px 0
		}
	}

	.background-masker {
		background: #fff;
		position: absolute;
	}

	/* Every thing below this is just positioning */

	.background-masker.header-top,
	.background-masker.header-bottom,
	.background-masker.subheader-bottom {
		top: 0;
		left: 40px;
		right: 0;
		height: 10px;
	}

	.background-masker.header-left,
	.background-masker.subheader-left,
	.background-masker.header-right,
	.background-masker.subheader-right {
		top: 10px;
		left: 40px;
		height: 8px;
		width: 10px;
	}

	.background-masker.header-bottom {
		top: 18px;
		height: 6px;
	}

	.background-masker.subheader-left,
	.background-masker.subheader-right {
		top: 24px;
		height: 8px;
	}


	.background-masker.header-right,
	.background-masker.subheader-right {
		width: auto;
		left: 300px;
		right: 0;
	}

	.background-masker.subheader-right {
		left: 230px;
	}

	.background-masker.subheader-bottom {
		top: 32px;
		height: 10px;
	}

	.background-masker.content-top,
	.background-masker.content-second-line,
	.background-masker.content-third-line,
	.background-masker.content-fourth-line,
	.background-masker.content-second-end,
	.background-masker.content-third-end,
	.background-masker.content-fourth-end,
	.background-masker.content-first-end {
		top: 40px;
		left: 0;
		right: 0;
		height: 10px;
	}

	.background-masker.content-second-line {
		height: 18px
	}

	.background-masker.content-top {
		height: 20px;
	}

	.background-masker.content-first-end,
	.background-masker.content-second-end,
	.background-masker.content-third-end,
	.background-masker.content-fourth-end {
		width: auto;
		left: 240px;
		right: 0;
		top: 60px;
		height: 8px;
	}

	.background-masker.content-second-line  {
		top: 68px;
	}

	.background-masker.content-second-end {
		left: 620px;
		top: 86px;
	}

	.background-masker.content-third-line {
		top: 94px;
	}

	.background-masker.content-third-end {
		left: 340px;
		top: 104px;
	}

	.background-masker.content-fourth-line {
		top: 112px;
	}

	.background-masker.content-fourth-end {
		left: 300px;
		top: 122px;
	}
</style>